import React from 'react';

const TableBody = ({ children, className = '', ...props }) => {
  return (
    <tbody className={`bg-white divide-y divide-gray-200 ${className}`} {...props}>
      {children}
    </tbody>
  );
};

const TableRow = ({ 
  children, 
  clickable = false,
  // "= undefined" makes the prop optional for TypeScript callers.
  onClick = undefined,
  href = undefined,
  onKeyDown = undefined,
  className = '',
  ...props 
}) => {
  const handleClick = (e) => {
    if (!clickable || !onClick) return;
    
    // Allow browser default behavior for:
    // - Ctrl+Click (Windows/Linux) or Cmd+Click (Mac) - open in new tab
    // - Shift+Click - open in new window
    // - Middle click - open in new tab
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
      // For modifier keys, open in new tab/window
      if (href) {
        const url = typeof href === 'string' ? href : href.toString();
        if (e.ctrlKey || e.metaKey || e.button === 1) {
          window.open(url, '_blank');
        } else if (e.shiftKey) {
          window.open(url, '_blank');
        }
      }
      return;
    }
    
    // For regular clicks, use custom navigation
    onClick(e);
  };

  const handleKeyDown = (e) => {
    if (clickable && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick(e);
    }
    if (onKeyDown) onKeyDown(e);
  };

  const baseClasses = clickable 
    ? 'even:bg-gray-50/50 hover:bg-gray-100 cursor-pointer' 
    : 'even:bg-gray-50/50 hover:bg-gray-100';

  return (
    <tr
      className={`${baseClasses} ${className}`}
      onClick={clickable ? handleClick : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : undefined}
      {...props}
    >
      {children}
    </tr>
  );
};

const TableCell = ({ 
  children, 
  // "= undefined" makes the prop optional for TypeScript callers.
  responsive = undefined,
  align = 'left',
  className = '',
  ...props 
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const responsiveClasses = {
    md: 'hidden md:table-cell',
    lg: 'hidden lg:table-cell',
    xl: 'hidden xl:table-cell'
  };

  const responsiveClass = responsive ? responsiveClasses[responsive] : '';
  const alignClass = alignClasses[align];

  return (
    <td 
      className={`px-4 py-2 whitespace-nowrap text-xs text-gray-900 ${alignClass} ${responsiveClass} ${className}`}
      {...props}
    >
      {children}
    </td>
  );
};

export default TableBody;
export { TableRow, TableCell };
